import makeApiCall from '.'
import { ChangeShippingOptionPayload, SubmitOrderPayload, SubmitOrderResponse } from 'types/orders'

export function orderDrugs(payload: SubmitOrderPayload) {
  return makeApiCall<SubmitOrderResponse>(`/orders`, 'post', payload)
}

export function changeShippingOption(orderId: string, payload: ChangeShippingOptionPayload) {
  return makeApiCall(`/orders/${orderId}/change-shipping-option`, 'post', payload)
}

export function addToFavoritesPharmacy(pharmacyId: string) {
  return makeApiCall(`/users/favourites`, 'post', pharmacyId)
}

export function cancelOrder(id: string) {
  return makeApiCall(`/orders/${id}/cancel`, 'post')
}

export function reOrder(id: string) {
  return makeApiCall(`/orders/${id}/reorder`, 'post')
}

export function addToCart(payload: { id: string; items: any[] }) {
  return makeApiCall<SubmitOrderResponse>(`/order-requests/${payload.id}/add-items`, 'post', {
    items: payload.items,
  })
}

export function removeFromCart(payload: { id: string; items: any[] }) {
  return makeApiCall(`/orders/${payload.id}/remove-items`, 'post', {
    items: payload.items,
  })
}
export function cancelOrderRequest(id: string) {
  return makeApiCall(`/order-requests/${id}/abort`, 'post')
}

export function calculateEstimate(payload: SubmitOrderPayload) {
  return makeApiCall<{
    total_order_cost: number
    total_shipping_cost: number
    total_processing_fee: number
    total_discount: number
  }>('/orders/estimate', 'post', payload)
}
